/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Feature_JuniorInputs */

const en_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior development from age 8`)
};

const es_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo junior desde los 8 años`)
};

const de_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorenförderung ab 8 Jahren`)
};

const zh_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 8 岁起的青少年培养`)
};

const ar_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير الناشئين من سن 8`)
};

const fr_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement junior dès 8 ans`)
};

const vi_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát triển junior từ 8 tuổi`)
};

const sw_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maendeleo ya vijana kuanzia umri wa miaka 8`)
};

const th_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พัฒนาจูเนียร์ตั้งแต่อายุ 8 ปี`)
};

const bs_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior razvoj od 8 godina`)
};

const ja_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8歳からのジュニア育成`)
};

const ko_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8세부터 주니어 육성`)
};

const pt_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento júnior desde os 8 anos`)
};

const it_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppo Junior da 8 anni`)
};

const sv_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorutveckling från 8 års ålder`)
};

const nl_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior ontwikkeling vanaf 8 jaar`)
};

const da_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior udvikling fra alder 8`)
};

const nb_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorutvikling fra 8 år`)
};

const fi_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junioritoimintaa 8-vuotiaista alkaen`)
};

const pl_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwój młodzieży w wieku od 8 lat`)
};

const ru_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юниорская программа с 8 лет`)
};

const tr_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 yaşından itibaren junior gelişimi`)
};

const hi_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 साल की उम्र से जूनियर विकास`)
};

const id_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembangan junior dari usia 8`)
};

const ms_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangunan pemain junior dari usia 8 tahun`)
};

const cs_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozvoj juniorů od 8 let`)
};

const el_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανάπτυξη νέων παικτών από 8 ετών`)
};

const he_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פיתוח שחקנים צעירים מגיל 8`)
};

const af_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juniorontwikkeling vanaf 8 jaar`)
};

const hu_home_feature_junior = /** @type {(inputs: Home_Feature_JuniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ifjúsági fejlesztés 8 éves kortól`)
};

/**
* | output |
* | --- |
* | "Junior development from age 8" |
*
* @param {Home_Feature_JuniorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_feature_junior = /** @type {((inputs?: Home_Feature_JuniorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Feature_JuniorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_feature_junior(inputs)
	if (locale === "de") return de_home_feature_junior(inputs)
	if (locale === "zh") return zh_home_feature_junior(inputs)
	if (locale === "ar") return ar_home_feature_junior(inputs)
	if (locale === "fr") return fr_home_feature_junior(inputs)
	if (locale === "vi") return vi_home_feature_junior(inputs)
	if (locale === "sw") return sw_home_feature_junior(inputs)
	if (locale === "th") return th_home_feature_junior(inputs)
	if (locale === "bs") return bs_home_feature_junior(inputs)
	if (locale === "ja") return ja_home_feature_junior(inputs)
	if (locale === "ko") return ko_home_feature_junior(inputs)
	if (locale === "pt") return pt_home_feature_junior(inputs)
	if (locale === "it") return it_home_feature_junior(inputs)
	if (locale === "sv") return sv_home_feature_junior(inputs)
	if (locale === "nl") return nl_home_feature_junior(inputs)
	if (locale === "da") return da_home_feature_junior(inputs)
	if (locale === "nb") return nb_home_feature_junior(inputs)
	if (locale === "fi") return fi_home_feature_junior(inputs)
	if (locale === "pl") return pl_home_feature_junior(inputs)
	if (locale === "ru") return ru_home_feature_junior(inputs)
	if (locale === "tr") return tr_home_feature_junior(inputs)
	if (locale === "hi") return hi_home_feature_junior(inputs)
	if (locale === "id") return id_home_feature_junior(inputs)
	if (locale === "ms") return ms_home_feature_junior(inputs)
	if (locale === "cs") return cs_home_feature_junior(inputs)
	if (locale === "el") return el_home_feature_junior(inputs)
	if (locale === "he") return he_home_feature_junior(inputs)
	if (locale === "af") return af_home_feature_junior(inputs)
	if (locale === "hu") return hu_home_feature_junior(inputs)
	return en_home_feature_junior(inputs)
});